var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { Basic } from "../../components/Form";
import { InputWithSubmit } from "../../components/Form/InputWithSubmit/InputWithSubmit";
import { getClassName } from "../../helpers/getClassName";
import { SIGN_IN_BUTTON_ERRORED, SIGN_IN, SIGN_IN_BUTTON, SIGN_IN_FORM } from "../../classConstants";
export var SignInForm = memo(function (props) {
    var _a;
    var _b = useState(''), email = _b[0], setEmail = _b[1];
    var _c = useState(''), error = _c[0], setError = _c[1];
    var _d = useState(false), completed = _d[0], setCompleted = _d[1];
    var t = useTranslation().t;
    var changeEmail = useCallback(function (email) {
        setEmail(email);
    }, []);
    var onSend = useCallback(function (e) {
        e.preventDefault();
        var trimmedMail = email.trim();
        if (!trimmedMail)
            return;
        setError('');
        return props.authenticate(trimmedMail).then(function (response) {
            switch (response === null || response === void 0 ? void 0 : response.name) {
                case "end_user_validation_failed":
                    setError(response.body.field_validation_errors.body.email[0]);
                    return;
            }
            setCompleted("auth_request_failed" !== (response === null || response === void 0 ? void 0 : response.name));
        });
    }, [props.authenticate, email]);
    var onReset = useCallback(function () {
        setCompleted(false);
        setEmail('');
        setError('');
    }, []);
    var authLinkSent = useMemo(function () {
        var html = t('authentication.auth_link_sent', {
            resend: "<resend />",
        });
        var authLinkSent = parse(html, {
            replace: function (node) {
                if (node.name === 'resend')
                    return React.createElement("button", { onClick: onReset }, t("authentication.resend"));
                return node;
            }
        });
        return authLinkSent;
    }, [t, onReset]);
    if (completed)
        return React.createElement(Basic, { as: "p" }, authLinkSent);
    return React.createElement(SignInFormStyled, { onSubmit: onSend },
        React.createElement("h2", null, t('authentication.sign_in_header')),
        React.createElement(InputWithSubmit, { name: "email", type: "email", value: email, error_message: error, placeholder: t('authentication.email'), label: t('authentication.email'), disabled: props.isAuthenticating, buttonDisabled: !email.trim(), onChange: changeEmail, wrapperClassName: SIGN_IN_FORM, onSubmit: onSend, className: SIGN_IN, submitLabel: t('authentication.sign_in'), buttonClassName: getClassName((_a = {},
                _a[SIGN_IN_BUTTON] = true,
                _a[SIGN_IN_BUTTON_ERRORED] = !!error,
                _a)) }));
});
var SignInFormStyled = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", "-input-wrapper {\n        flex-grow: 1;\n    }\n"], ["\n    .", "-input-wrapper {\n        flex-grow: 1;\n    }\n"])), SIGN_IN_FORM);
var templateObject_1;
